var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_radial_764_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2012 10.7896C13.2012 9.91213 12.6678 9.50885 12.0097 9.88877C11.3517 10.2687 10.8182 11.288 10.8182 12.1654C10.8182 13.0428 11.3517 13.4461 12.0097 13.0662C12.6677 12.6862 13.2012 11.667 13.2012 10.7896Z",
    fill: "url(#paint1_linear_764_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2991 7.84631C18.2991 6.96889 17.7656 6.56561 17.1075 6.94553C16.4495 7.32545 15.916 8.34475 15.916 9.22213C15.916 10.0996 16.4495 10.5028 17.1075 10.1229C17.7656 9.74299 18.2991 8.7237 18.2991 7.84631Z",
    fill: "url(#paint2_linear_764_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.195 16.4022C13.1453 16.4022 13.095 16.3896 13.0488 16.3631C12.9081 16.2822 12.8595 16.1025 12.9404 15.9617C12.9848 15.8845 14.0445 14.0656 15.5406 13.6842C16.1358 13.5325 16.7153 13.6259 17.2631 13.9618C17.4015 14.0467 17.4449 14.2277 17.36 14.3662C17.2752 14.5046 17.0941 14.548 16.9557 14.4631C16.5427 14.2098 16.1273 14.1414 15.6858 14.254C14.4279 14.5747 13.4598 16.2379 13.4502 16.2546C13.3958 16.3492 13.2968 16.4022 13.195 16.4022Z",
    fill: "url(#paint3_linear_764_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2791 16.7787L12.0437 14.1738C11.8941 13.8583 11.4452 13.8583 11.2955 14.1738L10.0598 16.7786C10.0598 16.7786 9.90033 17.1532 9.90033 17.5136C9.90033 18.5335 10.7631 19.3518 11.7986 19.2784C12.6549 19.2177 13.3519 18.5361 13.4312 17.6814C13.4612 17.3574 13.4031 17.0499 13.2791 16.7787Z",
    fill: "url(#paint4_radial_764_57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_764_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3416 4.82055) scale(14.2846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7E041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_764_57",
    x1: 12.0097,
    y1: 13.2903,
    x2: 10.3328,
    y2: 10.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401B06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_764_57",
    x1: 17.1076,
    y1: 10.3471,
    x2: 15.4306,
    y2: 7.44259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401B06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_764_57",
    x1: 15.1523,
    y1: 16.4022,
    x2: 15.1523,
    y2: 13.6137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B451C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401B06"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_764_57",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7864 18.2643) scale(2.33875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#59ACF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F97F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCry);
export default __webpack_public_path__ + "static/media/Cry.dca7e03a04fa7225cb81761520bec2c6.svg";
export { ForwardRef as ReactComponent };